import { Controller } from "@hotwired/stimulus"
import { smsHasLink } from "../lib/sms_link"

// How you'll meet (#15842), inside each Event Types form: shows a type's
// details panel only while its chip is checked, the own-link field only for
// "Use my own link", and an inline hint when no way to meet is left. The
// server stays the authority (CalendarEventMeetingOptions validations); the
// checkboxes' own change events already let card-dirty enable Save.
//
// #17956: a link in the meeting link or the address reaches the client in the
// first appointment text ({{appointment.meeting_details}}), before they have
// replied. Each linkInput's matching linkNudge (same data-field) shows while
// the value holds a link — a nudge, never a block (owner 2026-10-18).
export default class extends Controller {
  static targets = ["type", "panel", "provider", "ownLink", "noneHint", "linkInput", "linkNudge"]

  connect() {
    this.refresh()
  }

  refresh() {
    const checked = this.typeTargets.filter((box) => box.checked).map((box) => box.value)
    this.panelTargets.forEach((panel) => {
      panel.hidden = !checked.includes(panel.dataset.type)
    })
    if (this.hasNoneHintTarget) this.noneHintTarget.hidden = checked.length > 0

    const provider = this.providerTargets.find((radio) => radio.checked)?.value
    if (this.hasOwnLinkTarget) this.ownLinkTarget.hidden = provider !== "own_link"
    this.checkLinks()
  }

  checkLinks() {
    this.linkNudgeTargets.forEach((nudge) => {
      const input = this.linkInputTargets.find((field) => field.dataset.field === nudge.dataset.field)
      nudge.hidden = !smsHasLink(input?.value)
    })
  }
}
